import { useIsUserSignedIn } from "../../../core_stores/useAuthStore";
import { RankedApp, StoreType } from "../../../model/rankings";
import { AppStoreRankingItem } from "./AppStoreRankingItem";

interface AppStoreRankingColumnProps {
  apps: RankedApp[];
  store: StoreType;
  country: string;
}

const MAX_ANONYMOUS_APPS = 30;

export function AppStoreRankingColumn({
  apps,
  store,
  country,
}: AppStoreRankingColumnProps) {
  const isUserSignedIn = useIsUserSignedIn();

  // Limit apps for anonymous users
  const visibleApps = isUserSignedIn
    ? apps
    : apps.slice(0, MAX_ANONYMOUS_APPS);

  return (
    <div className="relative">
      <div className="flex flex-col">
        {visibleApps.map((app, index) => (
          <AppStoreRankingItem
            key={app.id}
            app={app}
            store={store}
            country={country}
            lazy={index >= 15}
          />
        ))}
      </div>
      {/* Fade out effect for anonymous users */}
      {!isUserSignedIn && (
        <div className="absolute left-0 right-0 bottom-0 h-24 bg-gradient-to-t from-dark-surface-primary to-transparent pointer-events-none" />
      )}
    </div>
  );
}
